import axios from '@/shared/api/axios';
import { CompanySimpleResponseDTO } from '../types';

interface GetCompanyListResponse {
  success: boolean;
  data: CompanySimpleResponseDTO[];
  message?: string;
}

export const getCompanyList = async (workspaceName: string): Promise<GetCompanyListResponse> => {
  const response = await axios.get<GetCompanyListResponse>(`/v1/hub/companies/by-workspace/${workspaceName}`);
  return response.data;
};  